import { render, staticRenderFns } from "./studyExam.vue?vue&type=template&id=03d95460&scoped=true"
import script from "./studyExam.vue?vue&type=script&lang=js"
export * from "./studyExam.vue?vue&type=script&lang=js"
import style0 from "./studyExam.vue?vue&type=style&index=0&id=03d95460&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d95460",
  null
  
)

export default component.exports